import { WhiteLinearGradient } from "../../utils/Utils";

function RefundPolicy() {
  return (
    <div
      className={`font-open-sans text-primary-midBlack text-opacity-80  py-10 `}
    >
      <p className="text-xl font-bold">Refund or Cancellation Policy</p>
      <p className="mt-4">
        Getactyv provides prepaid plans only and hence they are non-refundable
        and non-cancelable under any circumstances.
      </p>
    </div>
  );
}

export default RefundPolicy;
